import React, { useContext, useEffect } from "react";
import { Col, ListGroup, ListGroupItem, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { AppContext } from "../context/appContext";
import { addNotifications, resetNotifications } from "../features/userSlice";

import "./SideBar.css";

const SideBar = () => {
    const dispatch = useDispatch();
    const {
        socket,
        members,
        setMembers,
        currentRoom,
        setCurrentRoom,
        rooms,
        setRooms,
        newMessages,
        privateMemberMessage,
        setPrivateMemberMessage,
    } = useContext(AppContext);
    socket.off("new-user").on("new-user", (payload) => {
        setMembers(payload);
    });
    const user = useSelector((state) => state.user);

    const getRooms = () => {
        fetch("https://chatterboxx-backend.herokuapp.com/rooms")
            .then((res) => res.json())
            .then((data) => setRooms(data));
    };
    const joinRoom = (room, isPublic = true) => {
        if (!user) {
            return alert("please ensure you are logged in");
        }
        socket.emit("join-room", room);
        setCurrentRoom(room);
        if (isPublic) {
            setPrivateMemberMessage(null);
        }
        //dispatch notifications
        dispatch(resetNotifications(room));
        socket.off("notifications").on("notifications", (room) => {
            dispatch(addNotifications(room));
        });
    };
    //sort the private room ids
    const sortIds = (id1, id2) => {
        if (id1 > id2) {
            return id1 + "-" + id2;
        } else {
            return id2 + "-" + id1;
        }
    };

    const handlePrivateMemberMsg = (member) => {
        setPrivateMemberMessage(member);
        const roomId = sortIds(user._id, member._id);
        joinRoom(roomId, false);
    };
    useEffect(() => {
        if (user) {
            setCurrentRoom("general");
            getRooms();
            socket.emit("join-room", "general");
            socket.emit("new-user");
        }
    }, []);
    if (!user) {
        return (
            <div className="alert alert-danger">
                Login or Register to view available rooms
            </div>
        );
    }
    return (
        <>
            <h2>Common rooms</h2>
            <ListGroup style={{ cursor: "pointer" }}>
                {rooms.map((room, index) => (
                    <ListGroupItem
                        onClick={() => joinRoom(room)}
                        active={room == currentRoom}
                        key={index}
                    >
                        {room}{" "}
                        {currentRoom !== room && (
                            <span className="badge rounded-pill bg-primary">
                                {user.newMessages[room]}
                            </span>
                        )}
                    </ListGroupItem>
                ))}
            </ListGroup>
            <h2>Private member chats</h2>
            {members.map((member) => (
                <ListGroup style={{ cursor: "pointer" }}>
                    <ListGroupItem
                        key={member.id}
                        active={privateMemberMessage?._id === member._id}
                        onClick={() => handlePrivateMemberMsg(member)}
                        hidden={member._id === user._id}
                    >
                        <Row>
                            <Col xs={2} className="member-status">
                                <img
                                    src={member.picture}
                                    className="member-status-img"
                                />
                                {member.status === "online" ? (
                                    <i className="fa fa-circle sidebar-online-status"></i>
                                ) : (
                                    <i className="fa fa-circle sidebar-offline-status"></i>
                                )}
                            </Col>
                            <Col xs={9}>
                                {member.firstName}
                                {member._id === user?._id && " (me)"}
                                {member.status === "offline" && " (offline)"}
                            </Col>
                            <Col xs={1}>
                                <span className="badge rounded-pill bg-primary">
                                    {
                                        user.newMessages[
                                            sortIds(member._id, user._id)
                                        ]
                                    }
                                </span>
                            </Col>
                        </Row>
                    </ListGroupItem>
                </ListGroup>
            ))}
        </>
    );
};

export default SideBar;
